riot.tag2('bbc-notifications-idcta-html', '<span></span>', '', '', function(opts) {
'use strict';

var _this = this;

// Riot does not have a syntax for rendering raw, unescaped HTML content
// so we must create a component to render it.
var scriptsDone = [];

function evalScript(data) {
    var decodedData = decodeURI(data);
    if (scriptsDone.indexOf(decodedData) !== -1) {
        return;
    }

    var head = document.getElementsByTagName('head')[0] || document.documentElement;
    var script = document.createElement('script');

    script.type = 'text/javascript';
    script.appendChild(document.createTextNode(decodedData));
    head.insertBefore(script, head.firstChild);
    head.removeChild(script);

    console.log('idcta-html evaluating script', decodedData);
    scriptsDone.push(decodedData);
}

this.on('mount', function () {
    console.log('Mounted idcta-html', opts.html);

    _this.root.innerHTML = opts.html;
    if (opts.htmlJs) {
        evalScript(opts.htmlJs);
    }
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-idcta-html.tag
 ** module id = 22
 ** module chunks = 0
 **/